module.exports = __webpack_public_path__ + "img/dkt.89215324.png";